module.exports = __webpack_public_path__ + "img/verified-by-visa.8276d4f4.png";